// @ts-check
if (!customElements.get("ff-up-cross-selling-slider")) {
  class FfUpCrossSelling extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    async init() {
      const maxCartProducts = 4,
        maxRetrievedProducts = 4,
        maxReturnedRecommendations = 10,
        promises = [];
      let allRecommendations = [];

      if (
        !this ||
        !this.dataset.productsIds ||
        !this.dataset.url ||
        !this.dataset.intent
      )
        throw new Error();

      const swiper = new Swiper(".ff-cart-items-swiper", {
        slidesPerView: 1.7,
        speed: 400,
        spaceBetween: 8,
        mousewheel: true,
        autoplay: {
          delay: 5000,
        },
        breakpoints: {
          767: {
            slidesPerView: 1.7,
            spaceBetween: 12,
          },
          1227: {
            slidesPerView: 2,
            spaceBetween: 16,
          },
        },
      });

      const productsIds = Array.from(
        new Set(this?.dataset.productsIds?.split(","))
      );

      for (let i = 0; i < productsIds.length && i < maxCartProducts; i++) {
        const url = `${this.dataset.url}?product_id=${productsIds[i]}&intent=${this.dataset.intent}&limit=${maxRetrievedProducts}`;

        const promise = (async () => {
          const response = await fetch(url);
          const { products } = await response.json();
          allRecommendations = [...allRecommendations, ...products];
        })();

        promises.push(promise);
      }

      await Promise.allSettled(promises);

      allRecommendations
        .reduce((acc, curr) => {
          if (!acc.find((item) => item.id === curr.id)) {
            acc.push(curr);
          }
          return acc;
        }, [])
        .slice(0, maxReturnedRecommendations)
        .forEach((product, idx) => {
          const recommendationCard = this.recommendationCard(product, idx);

          if (recommendationCard) swiper.appendSlide(recommendationCard);
        });
    }

    /**
     *
     * @param {{variants: {id:string, price:number, name:string, available:boolean}[], featured_image:string, url:string}} product
     */
    recommendationCard(product, slideIdx) {
      const { featured_image, url, variants } = product;
      const firstVariantAvailable = variants.find(
        ({ available }) => available == true
      );

      if (!firstVariantAvailable) return undefined;
      const { price, name, id } = firstVariantAvailable;

      return `
        <ff-up-cross-selling-slider-card class="recommendation swiper-slide" data-variant-id="${id}" data-slide-idx="${slideIdx}">
          <a class="img-container" href="${url}">
            <img
              src=${featured_image}&width=100
              height="70"
              width="70"
            >
          </a>
          <div class="column">
            <a href="${url}"><h3 class="ff-max-lines-2 ff-text--color-base ff-text--sm">${name}</h3></a>
            <span class="price subdued ff-text--xs">
            ${new Intl.NumberFormat("de-DE", {
              style: "currency",
              currency: "EUR",
            }).format(price / 100)}
            </span>
            <button class="add-to-cart ff-general-cart_add_recommendation">
              Agregar
            </button>
          </div>
        </ff-up-cross-selling-slider-card>
      `;
    }
  }

  customElements.define("ff-up-cross-selling-slider", FfUpCrossSelling);
}

if (!customElements.get("ff-up-cross-selling-slider-card")) {
  customElements.define(
    "ff-up-cross-selling-slider-card",
    class FfCartPageRecommendationCard extends HTMLElement {
      constructor() {
        super();
        /**
         * @type {HTMLButtonElement | null}
         */
        this.addToCartBtn = this.querySelector(".add-to-cart");

        if (!this.addToCartBtn) throw new Error();
        this.addToCartBtn.addEventListener("click", this.addToCart.bind(this));
      }

      async addToCart() {
        this.addToCartBtn?.classList.add("btn--loading");
        this.addToCartBtn?.setAttribute("disabled", "disabled");

        /**
         * @type {HTMLDivElement | null}
         */
        const cartPage = document.querySelector(".cart-page");

        const swiper = document.querySelector(
          "ff-up-cross-selling-slider"
        )?.swiper;

        if (!this.dataset.variantId || !cartPage || !swiper) throw new Error();

        document.querySelector(".js-spinner").style.display = "";
        swiper.autoplay.stop();

        const id = parseInt(this.dataset.variantId);
        const requestData = {
          items: [{ id, quantity: 1 }],
          sections: cartPage
            .querySelector("ff-cart-page-line-item")
            .getSectionsToRender()
            .map((section) => section.id),
        };

        const {
          sections: { [cartPage.id]: section },
        } = await fetch(`${window["Shopify"].routes.root}cart/add.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        })
          .then((response) => {
            return response.json().then((data) => {
              cartPage
                .querySelector("ff-cart-page-line-item")
                .renderContents(data);

              return data;
            });
          })
          .catch((error) => {
            console.error("Error:", error);
            throw error;
          });

        const sectionDOM = new DOMParser().parseFromString(
          section,
          "text/html"
        );

        const cartItemsContainer = cartPage.querySelector(
          ".cart__line-items-container"
        );
        const newCartItemsContainer = sectionDOM.querySelector(
          ".cart__line-items-container"
        );
        const cartResume = cartPage.querySelector(".ff-cart-resume");

        /**
         * @type {HTMLButtonElement | null}
         */
        const checkoutButton = cartPage.querySelector(".cart-resume__submit");
        const newCartResume = sectionDOM.querySelector(".ff-cart-resume");

        /**
         * @type {HTMLButtonElement | null}
         */
        const newCheckoutButton = sectionDOM.querySelector(
          ".cart-resume__submit"
        );
        /**
         * @type {HTMLButtonElement}
         */

        if (cartResume && newCartResume) {
          cartResume.replaceWith(newCartResume);
        }

        if (cartItemsContainer && newCartItemsContainer) {
          cartItemsContainer.replaceWith(newCartItemsContainer);
        }

        if (newCheckoutButton && checkoutButton) {
          checkoutButton.style.display = newCheckoutButton.style.display;
        }

        this.addToCartBtn?.classList.remove("btn--loading");
        this.addToCartBtn?.removeAttribute("disabled");

        swiper.removeSlide(this.dataset.slideIdx);
        swiper.update();
        swiper.autoplay.start();

        cartPage
          .querySelectorAll("ff-up-cross-selling-slider .swiper-slide")
          .forEach((slide, idx) =>
            slide.setAttribute("data-slide-idx", idx.toString())
          );
        document.querySelector(".js-spinner").style.display = "none";
      }
    }
  );
}
